import React from 'react'
import PropTypes from 'prop-types'
import { LiStyled, UlStyled } from './styled'
import { generateID } from '../../../../../modules/generator-id/generator-id'
import { randomChangeColor } from '../../../../../modules/random-change-color/random-change-color'
import TextTitle from '../../../../infoAboutMe/title-h3/TextTitle'

const TechProject = ({ arrayString }) => {

  return (
    <>
      <TextTitle
        text="Tecnologies Used" 
          stylesElement={{
          fontSize: "1.5rem",
          marginTop: "15px",
          fontSize_lg: "2rem",
          fontSize_xl: "2rem",
        }}
      />
      
      <UlStyled>
        {arrayString.map(tech =>
          <LiStyled
            key={generateID()}
            color={randomChangeColor("#F7DF1F", "#707070" )}
          >{tech}</LiStyled>
        )}
      </UlStyled>
      
    </>
  )
}

TechProject.propTypes = {
  arrayString: PropTypes.array.isRequired,
}

export default TechProject
